BinderLiveFavorites = window.BinderLiveFavorites = (function () {
    return {
        bind: BinderLive.bindFavorites,
        unBind: BinderLive.unBindFavorites,
        name: 'BinderLiveFavorites',
        url: '/Live/GetFavoritesViewSet',
    };
})();

ScopeLiveFavorites = (function () {
    function init() {
        app.VerticalMenu.init();
        TableFetcherLive.setMode.favorites();
        app.ModeTableLive.init();

        app.Search.init('live');
    }

    function dispose() {
        app.VerticalMenu.dispose();
        app.ModeTableLive.dispose();
    }

    var start = function (justLoaded) {
        init();
    };
    var stop = function () {
        dispose();
    };

    return {
        start: start,
        stop: stop,
        name: 'ScopeLiveFavorites',
        url: 'LIVE/FAVORITES',
        title: Localization.getString('Shared.FavoriteLive', 'Лайв:Избранное'),
    };
})();
